





















import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';
import { GetOrdersParams } from '@/store/modules/order/order.types';
import BasePaginatorHoc from '@/components/base/BasePaginatorHoc.vue';
import OrderList from './OrderList.vue';
import SearchBox from './SearchBox.vue';
import OrdersMixin from '../mixin/orders.mixin';

@Component({
  components: {
    BasePaginatorHoc,
    SearchBox,
    OrderList
  }
})
export default class SoftwareTab extends mixins(OrdersMixin as any) {
  // --- Vuex bindings specific to Software Orders ---
  // These will be used by the mixin.

  @Action('order/getMySoftwareOrders')
  public fetchOrdersAction!: (options: GetOrdersParams) => void;

  @State((state: RootState) => state.order.softwareOrders)
  private softwareOrders!: RootState['order']['softwareOrders'];

  @State((state: RootState) => state.order.apiState.getMySoftwareOrders)
  private getMySoftwareOrdersState!: ApiState;

  // --- Computed properties to provide data to the mixin ---

  get ordersData() {
    return this.softwareOrders;
  }

  get apiStateForOrders() {
    return this.getMySoftwareOrdersState;
  }

  // --- Component-specific computed properties ---

  get OrderList() {
    return OrderList;
  }
}
